import { useContentMaxWidth } from '../../../hooks/ui/useContentMaxWidth';

// a diary field or memo card wider than this stops reading as a card
const DIARY_MAX_WIDTH = 720;

/** Diary frames follow the session column, capped near a card width. */
export const useDiaryMaxWidth = () => {
  return Math.min(useContentMaxWidth(), DIARY_MAX_WIDTH);
};
